import styled from 'styled-components';

export const Image = styled.img`
  max-height: 245px;
  margin: 20px 0;
  margin-right: 25px;
`;
